import {MARKET} from '../config';

export const getCurrency = () => {
    return MARKET === 'cz'
        ? 'CZK'
        : (MARKET === 'pl'
            ? 'PLN'
            : (MARKET === 'hu'
                ? 'HUF'
                : 'EUR'));
};
